// ==========================================================================
// ProductCardHe > Client > Nav > Modules
// ==========================================================================

const loader = () =>
    import(
        /* webpackChunkName: "nav" */
        './index'
    );

module.exports = {
    initNav: async instance => {
        const {
            default: { initNav: init }
        } = await loader();

        init(instance);
    }
};
